export type PointLightConfig = {
    type: "point";
    position: [number, number, number];
    intensity: number;
    color?: string;
    distance?: number;
    castShadow?: boolean;
};

export type AmbientLightConfig = {
    type: "ambient";
    intensity: number;
    color?: string;
    position: [number, number, number];
};

export type SpotLightConfig = {
    type: "spot";
    intensity: number;
    position: [number, number, number];
    target: [number, number, number];
    color?: string;
    distance?: number;
    angle?: number;
    penumbra?: number;
    castShadow?: boolean;
};

export type DirectionalLightConfig = {
    type: "directional";
    intensity: number;
    position: [number, number, number];
    target: [number, number, number];
    color?: string;
    castShadow?: boolean;
};

export type LightConfig =
    | PointLightConfig
    | AmbientLightConfig
    | DirectionalLightConfig
    | SpotLightConfig;

export const DEFAULT_LIGHT_CONFIG: LightConfig[] = [
    { type: "ambient", intensity: 0.5, position: [0, 0.5, 0], color: "#fffff0" },
    { type: "directional", intensity: 2, position: [0, 5, 1], target: [0, 0, 0] },
    {
        type: "spot",
        intensity: 10,
        position: [0, 4, 0],
        target: [0, 0, 0],
        castShadow: true,
        penumbra: 0.2,
        angle: 1.7,
        distance: 30,
    },
];
